"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERR_INVALID_SOCKET = exports.ERR_INVALID_PROVIDER = void 0;

var _providers = require("./providers");

/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var ERR_INVALID_PROVIDER = "Invalid value passed to WebSocket provider - ".concat(_providers.WS_PROVIDER);
exports.ERR_INVALID_PROVIDER = ERR_INVALID_PROVIDER;
var ERR_INVALID_SOCKET = 'Invalid socket argument!';
exports.ERR_INVALID_SOCKET = ERR_INVALID_SOCKET;